<!-- Label for a single unit on the disposition map -->
<template>
    <div class="location-unit">
        <c-tag
            :label           = "contract"
            :active          = "false"
            background-color = "primary"
        />

        <div
            class="location-unit-elevator-no"
            :class="active ? 'black--text' : 'lightgray'"
        >
            {{ unit.elevatorNo }}
        </div>

        <div
            class="location-unit-elevator-no black--text"
        >
            {{ unit.technicianName }}
        </div>
    </div>
</template>

<script>
import CTag from "@/modules/core/components/utils/CTag.vue";
import Site from "@/modules/msd/unit/service/Site";

export default {
    name: "CInspectionMapUnit",
    components: {
        CTag
    },

    props: {
        unit: {

        }
    },

    computed: {
        active () {
            if (!this.unit.status) {
                return false;
            }

            return this.unit.status.id === 1;
        },

        contract () {
            if (!this.unit.contractLimTypeId) {
                return !this.unit.id ? "NEU" : "P";
            }

            switch (this.unit.contractLimTypeId) {
                case Site.CONTRACT.LIM:
                    return "LIM";
                case Site.CONTRACT.DLS:
                    return "DLS";
            }

            return "P";
        },
    }
}
</script>

<style scoped>

.location-unit {
    margin-left: 4px;
    display: flex;
}

.location-unit-elevator-no {
    padding-top: 4px;
    margin-left: 8px;
}

</style>